var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloseEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", {
    style: {
      stroke: "none",
      strokeWidth: 0,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "none",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: "translate(1.4065934065934016 1.4065934065934016) scale(2.81 2.81)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 12.39 79.61 c -0.512 0 -1.024 -0.195 -1.414 -0.586 c -0.781 -0.781 -0.781 -2.047 0 -2.828 l 65.221 -65.221 c 0.781 -0.781 2.047 -0.781 2.828 0 c 0.781 0.781 0.781 2.047 0 2.828 L 13.804 79.024 C 13.414 79.415 12.901 79.61 12.39 79.61 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 24.826 67.173 c -0.333 0 -0.67 -0.083 -0.981 -0.258 C 16.058 62.52 8.19 55.576 0.462 46.278 c -0.616 -0.741 -0.616 -1.816 0 -2.557 C 22.128 17.656 44.23 10.712 66.155 23.085 c 0.962 0.543 1.301 1.763 0.759 2.725 c -0.544 0.962 -1.76 1.303 -2.726 0.759 C 44.267 15.325 24.768 21.353 4.614 45 c 7.065 8.281 14.19 14.477 21.197 18.431 c 0.962 0.543 1.302 1.764 0.759 2.726 C 26.202 66.808 25.524 67.173 24.826 67.173 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 44.954 72.856 c -4.485 0 -8.968 -0.801 -13.445 -2.406 c -1.04 -0.373 -1.581 -1.519 -1.208 -2.558 c 0.374 -1.041 1.521 -1.582 2.558 -1.208 C 50.152 72.888 67.815 65.589 85.386 45 c -4.967 -5.821 -9.979 -10.632 -14.915 -14.314 c -0.885 -0.661 -1.067 -1.914 -0.407 -2.799 c 0.661 -0.886 1.914 -1.069 2.8 -0.407 c 5.545 4.137 11.155 9.601 16.675 16.242 c 0.616 0.741 0.616 1.816 0 2.557 C 74.839 63.962 59.894 72.856 44.954 72.856 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 45 64.103 c -2.084 0 -4.136 -0.335 -6.098 -0.995 c -1.047 -0.353 -1.61 -1.486 -1.257 -2.533 c 0.353 -1.048 1.483 -1.611 2.534 -1.258 c 1.549 0.521 3.171 0.786 4.821 0.786 c 8.327 0 15.103 -6.775 15.103 -15.103 c 0 -1.65 -0.265 -3.273 -0.786 -4.823 c -0.353 -1.047 0.211 -2.181 1.258 -2.534 s 2.182 0.212 2.533 1.257 c 0.66 1.962 0.995 4.014 0.995 6.099 C 64.103 55.533 55.533 64.103 45 64.103 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 32.907 59.093 c -0.512 0 -1.024 -0.195 -1.414 -0.586 c -3.608 -3.607 -5.595 -8.404 -5.595 -13.507 c 0 -10.533 8.569 -19.102 19.102 -19.102 c 5.041 0 9.797 1.946 13.391 5.479 c 0.787 0.774 0.798 2.041 0.023 2.828 c -0.772 0.788 -2.04 0.799 -2.828 0.024 c -2.841 -2.793 -6.601 -4.331 -10.586 -4.331 c -8.327 0 -15.102 6.775 -15.102 15.102 c 0 4.034 1.571 7.826 4.423 10.679 c 0.781 0.781 0.781 2.047 0 2.828 C 33.931 58.897 33.418 59.093 32.907 59.093 z",
    style: {
      stroke: "none",
      strokeWidth: 1,
      strokeDasharray: "none",
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 10,
      fill: "rgb(0,0,0)",
      fillRule: "nonzero",
      opacity: 1
    },
    transform: " matrix(1 0 0 1 0 0) ",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseEye);
export default __webpack_public_path__ + "static/media/close-eye.0bc16196c1e3b22fce9ceb0aebb38f24.svg";
export { ForwardRef as ReactComponent };